var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36066 8.12345C4.3278 8.09143 4.18726 7.97054 4.07166 7.85793C3.34463 7.19773 2.15463 5.47545 1.7914 4.57401C1.73303 4.43711 1.6095 4.091 1.60156 3.90608C1.60156 3.72888 1.64236 3.55997 1.7251 3.39878C1.8407 3.19785 2.0226 3.03666 2.23736 2.94834C2.3864 2.89148 2.83236 2.80316 2.8403 2.80316C3.3282 2.71484 4.12096 2.66626 4.99703 2.66626C5.83173 2.66626 6.5922 2.71484 7.08746 2.78715C7.0954 2.79543 7.6496 2.88375 7.83943 2.98035C8.18623 3.15755 8.40156 3.50366 8.40156 3.87406V3.90608C8.39306 4.14731 8.17773 4.65461 8.1698 4.65461C7.806 5.50747 6.67436 7.19 5.9224 7.86621C5.9224 7.86621 5.72916 8.05666 5.60846 8.13946C5.43506 8.26863 5.2203 8.33266 5.00553 8.33266C4.76583 8.33266 4.54256 8.26035 4.36066 8.12345Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBold);
export default __webpack_public_path__ + "static/media/arrow_down_bold.2ef74f690d153cb099956351f8983e5e.svg";
export { ForwardRef as ReactComponent };